import React, { useEffect, useState } from "react";
import { Popup } from "antd-mobile";
import "./css/RedEnvelpoe.css";
import general from "../../../../../general";

export default function RedEnvelopeAlert(props) {
  const { type, attach } = props;

  const handleAction = () => {
    if (props.handleAction) {
      props.handleAction(attach);
    }
  };

  return (
    <div>
      <Popup
        getContainer={props.getContainer}
        visible={props.visible}
        mask={false}
        disableBodyScroll={false}
        className="red-envelpoe-modal"
        position="top"
      >
        <div>
          <div className={`red-envelope-alert-container ${type}`}>
            <div className="red-envelope-alert-content">
              <img src="resources/251222/re_big.png" alt="" height={35} />
              <div className="red-envelope-alert-info">
                <div className="red-envelope-title">{attach?.title}</div>
                <div className="red-envelope-desc">
                  {type == "join_cluster_redenvelope" ||
                  parseInt(attach?.scene_type) == 1 ? (
                    <div
                      style={{
                        borderRadius: 4,
                        border: "0.5px solid #FF505B",
                        padding: "2px 5px",
                        display: "flex",
                        alignItems: "center",
                        fontSize: 12,
                        color: "#FF505B",
                        lineHeight: 1,
                      }}
                    >
                      <div>来自</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 7,
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={attach?.send_user.avator}
                          alt=""
                          height={14}
                        />
                      </div>
                      <div>{attach?.send_user.title}</div>
                    </div>
                  ) : (
                    <div className="red-envelope-value">
                      {parseInt(attach?.task_condition.task_type) == 1
                        ? "下载"
                        : "发帖"}
                      满
                      <span className="download">
                        {attach?.task_condition.completed_condition}/
                        {attach?.task_condition.totle_condition}
                      </span>
                      人 开抢
                    </div>
                  )}
                </div>
              </div>
              <div onClick={handleAction} className="btn">
                {attach?.task_condition.button_text}
              </div>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}
